import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, CreateDateColumn, UpdateDateColumn } from 'typeorm';

@Entity('designation_action')
export class DesignationAction {

    @PrimaryGeneratedColumn('increment', { name: 'designation_action_id' })
    designationActionId: number;

    @Column({
        nullable: false,
        name: 'designation_date',
        type: 'datetime',
        default: () => 'CURRENT_TIMESTAMP'
    })
    designationDate: Date;

    @Column('varchar', {
        length: 12,
        nullable: false,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'employee_name'
    })
    employeeName: string;

    
    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'department'
    })
    department: string;
    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'to_department'
    })
    toDepartment: string;

    @Column('int', {
        nullable: false,
        name: 'employee_id'
    })
    employeeId: number;

    @Column('varchar', {
        nullable: false,
        length: 60,
        name: 'from_designation'
    })
    fromDesignation: string;

    @Column({
        nullable: false,
        name: 'to_designation'
    })
    toDesignation: string;

    @Column('varchar', {
        nullable: true,
        length: 60,
        name: 'approved_by'
    })
    approvedBy: string;


    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    // @Column('int', {
    //     nullable: false,
    //     name: 'from_department_id'
    // })
    // fromDepartmentId:number;

    // @Column('int', {
    //     nullable: false,
    //     name: 'to_department_id'
    // })
    // toDepartmentId:number;
}

